import { render, staticRenderFns } from "./tournamentMatches.vue?vue&type=template&id=15264aaa&scoped=true&"
import script from "./tournamentMatches.vue?vue&type=script&lang=js&"
export * from "./tournamentMatches.vue?vue&type=script&lang=js&"
import style0 from "./tournamentMatches.vue?vue&type=style&index=0&id=15264aaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15264aaa",
  null
  
)

export default component.exports